/** Shared allowlist: Core AI may shape an existing table, never invent asset references. */
import { CORE_FX } from './synthCoreSchema';
const paths = [
 ...['mode','voices','quality','glide','glideMode','velocityToAmp','level'].map(key=>`voice.${key}`),
 ...['oscA','oscB'].flatMap(osc=>['enabled','table','position','level','pan','octave','semi','fine','unison','detune','blend','width','randomPhase','phase','envToPosition','warp.mode','warp.amount','warp.envAmount'].map(key=>`${osc}.${key}`)),
 ...['filter','filter2'].flatMap(filter=>['enabled','mode','cutoff','resonance','drive','keytrack','envAmount','velocityAmount',...(filter==='filter2'?['routing']:[])].map(key=>`${filter}.${key}`)),
 ...['ampEnv','modEnv'].flatMap(env=>['delay','attack','hold','decay','sustain','release','attackCurve','decayCurve','releaseCurve'].map(key=>`${env}.${key}`)),
 ...['level','octave','shape','pan'].map(key=>`sub.${key}`),...['level','color','pan'].map(key=>`noise.${key}`),
 ...Array.from({length:4},(_,i)=>`macros.${i}`),
 ...Array.from({length:4},(_,i)=>['shape','rate','sync','division','mode','phase','delay','rise'].map(key=>`lfos.${i}.${key}`)).flat(),
 ...Array.from({length:16},(_,i)=>['source','destination','amount','via'].map(key=>`matrix.${i}.${key}`)).flat(),
 ...CORE_FX.flatMap(effect=>['enabled',...effect.fields.map(field=>field.key)].map(key=>`fx.${effect.key}.${key}`))
];
export const CORE_AI_PATHS=Object.freeze([...new Set(paths)]);
const allowed=new Set(CORE_AI_PATHS);
export const isCoreAiPath=path=>{
 const match=/^layers\.[0-3]\.core\.(.+)$/.exec(path);
 return Boolean(match&&allowed.has(match[1]));
};
